var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 24,
    "aria-hidden": "true",
    className: "chevron_svg__c-icon__svg",
    viewBox: "0 0 11 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.244 19.002a.83.83 0 0 1 0-1.178l8.2-8.2-8.2-8.202A.832.832 0 1 1 1.423.244l8.789 8.79a.83.83 0 0 1 0 1.178l-8.79 8.79a.83.83 0 0 1-1.178 0"
  })));
};
export default SvgChevron;